import * as types from '../../actions/types';

const initialState = {
  categories: [],
  isLoading: false,
  error: null,
};

const blogCategory = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_BLOG_CATEGORIES_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.GET_BLOG_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
        isLoading: false,
        error: null,
      };
    case types.GET_BLOG_CATEGORIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case types.CREATE_BLOG_CATEGORY_SUCCESS:
    case types.UPDATE_BLOG_CATEGORY_SUCCESS:
    case types.DELETE_BLOG_CATEGORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default blogCategory;